import { Controller } from "@hotwired/stimulus"

// Displays the total cost to pay based on selected reservation option and accommodation.
// Values: freeOptionCost, restaurationCost, accommodations (JSON: { "uuid": price })
export default class extends Controller {
  static values = {
    freeOptionCost: { type: Number, default: 0 },
    restaurationCost: { type: Number, default: 0 },
    accommodations: { type: String, default: "{}" }
  }

  static targets = ["output"]

  connect() {
    this.accommodationsMap = this.parseAccommodations()
    this.update()
    this.bindRadios()
  }

  parseAccommodations() {
    try {
      return JSON.parse(this.accommodationsValue || "{}")
    } catch {
      return {}
    }
  }

  bindRadios() {
    const reservationRadios = this.element.querySelectorAll('input[name="retreat_inscription[reservation_option]"]')
    const accommodationRadios = this.element.querySelectorAll('input[name="retreat_inscription[accommodation_id]"]')

    reservationRadios.forEach((radio) => {
      radio.addEventListener("change", () => this.update())
    })
    accommodationRadios.forEach((radio) => {
      radio.addEventListener("change", () => this.update())
    })
  }

  update() {
    if (!this.hasOutputTarget) return

    const total = this.computeTotal()
    this.outputTarget.textContent = this.formatCurrency(total)
  }

  computeTotal() {
    const reservationRadio = this.element.querySelector('input[name="retreat_inscription[reservation_option]"]:checked')
    const option = reservationRadio?.value || "libre"

    const freeCost = Number(this.element.dataset.totalCostFreeOptionCostValue ?? this.freeOptionCostValue) || 0
    const restCost = Number(this.element.dataset.totalCostRestaurationCostValue ?? this.restaurationCostValue) || 0

    switch (option) {
      case "libre":
        return freeCost
      case "restauration":
        return restCost
      case "hebergement": {
        const accRadio = this.element.querySelector('input[name="retreat_inscription[accommodation_id]"]:checked')
        const accId = accRadio?.value
        return accId ? (Number(this.accommodationsMap[accId]) || 0) : 0
      }
      default:
        return 0
    }
  }

  formatCurrency(amount) {
    return new Intl.NumberFormat("fr-FR", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount) + " FCFA"
  }
}
